// extracted by mini-css-extract-plugin
export default {"overlay":"BaseLoading_overlay__zM+tu"};